<template>
  <div v-if="currentProduct && Object.keys(currentProduct).length" class="product-detail">
    <div class="title">{{ $t('detailHeader') }}</div>
    <div class="item">
      <div class="label">{{ $t('nameLabel') }}</div>
      <div class="desc">
        {{ currentProductName }}
      </div>
    </div>
    <div class="item">
      <div class="label">{{ $t('descLabel') }}</div>
      <div class="desc">
        <span>{{ $t('descContent') }}</span>
      </div>
    </div>
    <div class="item">
      <div class="label">{{ $t('periodLabel') }}</div>
      <div class="desc">
        {{ type==='fixed'
        ? `${currentProduct.term } ${$t(currentProduct.dateUnit)}`: $t('withdrawAnyTime') }}
      </div>
    </div>
    <div class="item">
      <div class="label">{{ $t('rateLabel') }}</div>
      <div class="desc">{{ currentProduct.interestPercent }}%</div>
    </div>
    <div v-if="currentProduct" class="item">
      <div class="label">{{ $t('minLabel') }}</div>
      <div class="desc">
        <span>
          {{ $t('minContent', [ 'Rp ' + (currentProduct.limitMinAmount || 0).toLocaleString('id') ]) }}
        </span>
        <span v-if="currentProduct.limitIncrementStep > 0">
          {{ $t('stepAmount', [ 'Rp ' + currentProduct.limitIncrementStep.toLocaleString('id') ]) }}
        </span>
      </div>
    </div>
    <div class="item">
      <div class="label">{{ $t('paymentTypeLabel') }}</div>
      <div class="desc">{{ type === 'fixed' ? $t('fixedPayment') : $t('flexiblePayment')}}</div>
    </div>
    <div class="item">
      <div class="label">{{ $t('escrowAccountLabel') }}</div>
      <div class="desc">{{ $t('escrowAccountContent') }}</div>
    </div>
    <div class="item">
      <div class="label">{{ $t('agreementLabel') }}</div>
      <div class="desc">
        <a :href="`/static/html/service-platform/service-platform-${$i18n.locale}.html`" target="_blank"
           class="detail-button">
          {{ $t('agreementContent') }}
        </a>
      </div>
    </div>
    <div class="item">
      <div class="label">{{ $t('riskLabel') }}</div>
      <div class="desc">
        <span>{{ $t('riskContent') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        detailHeader: 'Product Specifications',
        nameLabel: 'Product Name',
        descLabel: 'Product Description',
        descContent:
          'A lending facility for extending loans to high-quality Indonesian consumer borrowers, carefully selected by the Kredit Pintar platform.',
        periodLabel: 'Period of lending commitment',
        rateLabel: 'Expected Return Projections (Annualised)',
        minLabel: 'Minimum Lending Amount',
        minContent: 'The minimum lending amount is {0}.',
        stepAmount: 'You can make additional loans in {0}.',
        paymentTypeLabel: 'Return Profile',
        fixedPayment: 'Full Payment After Completion Period',
        flexiblePayment: 'Your p.a. interest will be calculated daily start from second day',
        escrowAccountLabel: 'Escrow account',
        escrowAccountContent: 'PT CIMB Niaga Tbk / PT Bank Central Asia Tbk / PT Bank Negara Indonesia (Persero) Tbk',
        agreementLabel: 'Agreement',
        agreementContent: 'Information technology-based Money Lending Services Agreement',
        riskLabel: 'Risk Disclosure',
        riskContent:
          'Kredit Pintar does not guarantee the granting or payment of the loan. The Lender understands and acknowledges that Kredit Pintar does not provide any advice, nor does it make any recommendations to the Lender on the lending. It is the Lender’s responsibility to assess whether the Lending Product is suitable or appropriate for its needs and any decision made to use the Lending Product is done so entirely at the Lender’s own risk. By using the Lending Product, the Lender confirms that it has understood the risks involved.',
        DAY: 'days',
        MONTH: 'month(s)',
        none: 'None',
        withdrawAnyTime: 'Withdraw anytime',
      },
      id: {
        detailHeader: 'Detil',
        nameLabel: 'Nama produk',
        descLabel: 'Deskripsi produk',
        periodLabel: 'Lama Periode',
        rateLabel: 'Laba dari Pendanaan',
        minLabel: 'Pendanaan minimum',
        minContent: 'Jumlah minimum pendanaan adalah {0}.',
        stepAmount: 'Dan jumlah untuk pendanaan tambahan adalah dalam kelipatan {0}',
        paymentTypeLabel: 'Jenis Pinjaman',
        fixedPayment: 'Pembayaran Penuh Setelah Periode Selesai',
        flexiblePayment: 'Bunga akan dihitung per hari dimulai dari hari kedua',
        escrowAccountLabel: 'Rekening escrow',
        escrowAccountContent: 'PT CIMB Niaga Tbk / PT Bank Central Asia Tbk / PT Bank Negara Indonesia (Persero) Tbk',
        agreementLabel: 'Perjanjian',
        agreementContent: 'Persetujuan pendanaan dengan pemberi pinjaman',
        descContent: 'Produk Pinjaman A adalah jenis pinjaman dana tunai yang akan dapat membantu masyarakat',
        riskLabel: 'Penjelasan Resiko',
        riskContent:
          'Pinjaman diproses secara online, nominal pinjaman berkisar antara Rp 500.000,- sampain dengan Rp 2.000.000,-. Kami melakukan pengawasan dan uji kelayakan terhadap resiko peminjam dan agunan opsional, namun Risiko Pinjaman atau Gagal Bayar ditanggung sepenuhnya oleh Pemberi Pinjaman. Tidak ada lembaga atau otoritas negara yang bertanggung jawab atas risiko gagal bayar ini.',
        DAY: 'hari',
        MONTH: 'bulan',
        none: 'Tidak ada batas',
        withdrawAnyTime: 'Tarik kapanpun',
      },
    },
  },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    currentProduct() {
      return this.$store.state.currentProduct
    },
    currentProductName() {
      try {
        return this.currentProduct.name[this.$i18n.locale]
      } catch (error) {
        return ''
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.product-detail {
  padding: 30px 24px 50px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9e9e9;
  margin-bottom: 16px;
}

.item {
  margin-bottom: 24px;
  font-size: 14px;
  .label {
    font-size: 12px;
    font-weight: 400;
    color: #666;
    margin-bottom: 8px;
  }
  .desc {
    font-size: 13px;
    color: #333;
    line-height: 1.3;
  }
}

.detail-button {
  font-size: 14px;
  color: #5981FF;
  font-weight: normal;
  text-decoration: none;
}
</style>
